import { render, staticRenderFns } from "./OrderMessages.vue?vue&type=template&id=0c312aaf&"
import script from "./OrderMessages.js?vue&type=script&lang=js&"
export * from "./OrderMessages.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports